import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { AmenityLocationSectionROW } from "../components/AmenityLocationSectionROW";
import { SiteRoadwaysSection } from "../components/SiteRoadwaysSection";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import DashboardHeader from "@components/Header/DashboardHeader";
import GenericBreadCrums from "@components/Breadcrumbs";
import { UploadedDocuments } from "../components/UploadedDocuments";
import { Consent } from "../components/Consent";
import { IndividualDetailsROW } from "../components/IndividualDetailsROW";
import { useNavigate } from "react-router-dom";
// import { ApplicantOrganisationDetails } from "../components/ApplicantOrganisationDetails";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootReducerType, RootState } from "@store/store";
// import { fetchApplicationPreview } from "./redux/thunk/PreviewThunk";
import { fetchApplicationPreviewROW } from "../application-preview/redux/thunk/PreviewROWThunk";

// import bgImage from "../../../assets/images/BG.svg";
import { setActiveStep } from "../../stepper/redux/stepperSlice";
import { MediaUpload } from "../components/MediaUpload";
import { ApplicantOrganisationDetailsROW } from "../components/ApplicantOrganisationDetailsROW";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { resetApplicationSubmitted } from "@modules/application-section/application-details/redux/applicationSubmittedSlice";

export const ApplicationPreviewDetailsROW: React.FC = () => {
  const breadcrumbData = [{ label: "Application Details", link: "#" }];
  const [isApplicationPreviewExpanded, setIsApplicationPreviewExpanded] =
    useState({
      individualDetails: true,
      organisationDetails: false,
      ammentiesDetails: false,
      siteRoadways: false,
      documents: false,
      consent: false,
      uploadMedia: false,
    });
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [consentCheck, setConsentCheck] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const handleAgree = () => {
    setShowDisclaimerModal(false);
  };

  const applicationPreviewROW = useSelector(
    (state: RootState) => state.applicationPreviewROW?.applicationPreview
  );

  const { access_id } = useSelector(
    (state: RootState) => state.amenitiesROW || {}
  );

  const applicationEditId = useSelector(
    (state: RootState) => state.applicationDashboard?.id || 0
  );

  const isApplicationSubmitted = useSelector(
    (state: RootReducerType) =>
      state.isApplicationSubmitted?.isApplicationSubmitted
  );

  // useEffect(() => {
  //   if (access_id) {
  //     dispatch(fetchApplicationPreview(66));
  //   }
  // }, [access_id, dispatch]);
  useEffect(() => {
    if (applicationEditId) {
      dispatch(fetchApplicationPreviewROW(applicationEditId));
    } else {
      dispatch(fetchApplicationPreviewROW(access_id));
    }
  }, [dispatch]);

  React.useEffect(() => {
    if (isApplicationSubmitted) {
      navigate(`/application-details-row`, { replace: true });
    }
  }, []);

  if (!applicationPreviewROW) return null;

  const allCollapsed = Object.values(isApplicationPreviewExpanded).every(
    (value) => value === false
  );

  if (!applicationPreviewROW) return;

  const toggleApplicationPreviewSections = (expanded: boolean) => {
    setIsApplicationPreviewExpanded({
      individualDetails: expanded,
      organisationDetails: expanded,
      ammentiesDetails: expanded,
      siteRoadways: expanded,
      documents: expanded,
      consent: expanded,
      uploadMedia: expanded,
    });
  };

  const handleRedirect = async () => {
    setShowDisclaimerModal(false);
    dispatch(setActiveStep(4));
    dispatch(resetApplicationSubmitted());
    navigate("/stepper-row");
  };

  const handleBack = async () => {
    dispatch(setActiveStep(2));
    dispatch(resetApplicationSubmitted());
    navigate("/stepper-row");
  };

  return (
    <Box
      className="login-root"
      sx={{
        // background: `url(${bgImage}) no-repeat top center`,
        backgroundSize: "cover", // or "contain" depending on your layout
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Disclaimer Modal */}
      <Dialog
        open={showDisclaimerModal}
        onClose={() => setShowDisclaimerModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            padding: 1,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
            pr: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WarningAmberIcon sx={{ color: "#ff9800", fontSize: 32 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: "#3a1c73" }}>
              Instructions
            </Typography>
          </Box>
          <IconButton
            onClick={() => setShowDisclaimerModal(false)}
            sx={{ color: "#666" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ mb: 2 }}>
            {/* <Typography
              variant="body1"
              sx={{
                fontSize: "1.1rem",
                fontWeight: 600,
                color: "#000",
                mb: 2,
              }}
            >
              Important Notice:
            </Typography> */}
            <Typography
              variant="body1"
              sx={{
                fontSize: "1rem",
                color: "#333",
                lineHeight: 1.7,
                mb: 2,
              }}
            >
              Before proceeding with the application submission, please review
              and verify all the information provided. All submitted details
              will be verified by the Authority. If any incorrect, incomplete,
              or misleading information is found, the application shall be
              cancelled.
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: 1,
              padding: 2.5,
              mb: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.95rem",
                color: "#856404",
                fontWeight: 600,
                mb: 1.5,
              }}
            >
              Please ensure the following:
            </Typography>
            <Box component="ul" sx={{ margin: 0, paddingLeft: 2.5 }}>
              <Typography component="li" sx={{ mb: 1, color: "#856404" }}>
                All personal and organization details are accurate and
                up-to-date.
              </Typography>
              <Typography component="li" sx={{ mb: 1, color: "#856404" }}>
                Site location and amenity information is correct and complete.
              </Typography>
              <Typography component="li" sx={{ mb: 1, color: "#856404" }}>
                All required documents have been uploaded and are clearly
                legible.
              </Typography>
              <Typography component="li" sx={{ mb: 1, color: "#856404" }}>
                Measurements, dimensions, and technical specifications are
                precise.
              </Typography>
              {/* <Typography component="li" sx={{ mb: 0, color: "#856404" }}>
                All consent declarations and acknowledgments are truthful
              </Typography> */}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
          <Button
            variant="contained"
            className="stepper-next-btn"
            sx={{ width: "auto" }}
            onClick={() => handleRedirect()}
          >
            I Agree
          </Button>
        </DialogActions>
      </Dialog>
      <div className="page-content">
        {/* <DashboardHeader /> */}
        <GenericBreadCrums breadcrumbs={breadcrumbData} className="mt-6" />
        <Box className="preview-wrapper">
          <Box className="preview-header">
            <Box className="preview-title-box">
              <Typography
                className="preview-title"
                sx={{ fontWeight: 700, fontSize: "18px" }}
              >
                Application Preview
              </Typography>
            </Box>
            <Box className="preview-controls">
              {allCollapsed ? (
                <Button
                  startIcon={<UnfoldMoreIcon className="rotate-45 brand-900" />}
                  onClick={() => toggleApplicationPreviewSections(true)}
                >
                  <Typography
                    className="brand-900"
                    sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                  >
                    Expand All
                  </Typography>
                </Button>
              ) : (
                <Button
                  startIcon={<UnfoldLessIcon className="rotate-45 brand-900" />}
                  onClick={() => toggleApplicationPreviewSections(false)}
                >
                  <Typography
                    className="brand-900"
                    sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                  >
                    Collapse All
                  </Typography>
                </Button>
              )}
            </Box>
          </Box>

          <Box className="preview-sections flex flex-col gap-6">
            <IndividualDetailsROW
              isExpanded={isApplicationPreviewExpanded.individualDetails}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  individualDetails: !prev.individualDetails,
                }))
              }
              data={applicationPreviewROW}
            />
            <ApplicantOrganisationDetailsROW
              isExpanded={isApplicationPreviewExpanded.organisationDetails}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  organisationDetails: !prev.organisationDetails,
                }))
              }
              data={applicationPreviewROW}
            />
            <AmenityLocationSectionROW
              isExpanded={isApplicationPreviewExpanded.ammentiesDetails}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  ammentiesDetails: !prev.ammentiesDetails,
                }))
              }
              data={applicationPreviewROW}
            />

            <SiteRoadwaysSection
              isExpanded={isApplicationPreviewExpanded.siteRoadways}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  siteRoadways: !prev.siteRoadways,
                }))
              }
              data={applicationPreviewROW}
            />
            <UploadedDocuments
              isExpanded={isApplicationPreviewExpanded.documents}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  documents: !prev.documents,
                }))
              }
            />
            <MediaUpload
              isExpanded={isApplicationPreviewExpanded.uploadMedia}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded((prev) => ({
                  ...prev,
                  uploadMedia: !prev.uploadMedia,
                }))
              }
            />
            {/* <Consent
              isExpanded={isApplicationPreviewExpanded.consent}
              toggleExpand={() =>
                setIsApplicationPreviewExpanded(prev => ({
                  ...prev,
                  consent: !prev.consent
                }))
              }
              setConsentCheck={setConsentCheck}
              consentCheck={consentCheck}
            /> */}
          </Box>
          <Box
            className="edit-box flex justify-end gap-3 align-center gray:br-t-500 pt-4"
            mt={2}
          >
            <Button
              variant="outlined"
              className="back-btn"
              // onClick={() => navigate("/stepper-row")}
              onClick={handleBack}
            >
              <Typography textTransform="initial">Back</Typography>
            </Button>
            <Button
              variant="contained"
              className="stepper-next-btn"
              onClick={() => {
                setShowDisclaimerModal(true);
              }}
            >
              {/* <Typography textTransform="initial">E- Signature</Typography> */}
              <Typography textTransform="initial">Next</Typography>
            </Button>
          </Box>
        </Box>
      </div>
    </Box>
  );
};
